import { render, staticRenderFns } from "./custom-dialog.vue?vue&type=template&id=df5f24ea&lang=pug&"
import script from "./custom-dialog.vue?vue&type=script&lang=ts&"
export * from "./custom-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports